import React, { useState } from "react";
import { ShoppingCart, User, Search, Menu } from "lucide-react";
import { useNavigate } from "react-router-dom";

function MainHeader() {
    const navigate = useNavigate();
   const [diagramHover, setDiagramHover] = useState(false);
  return (
   <div className="header-wrapper" style={styles.headerWrapper}>

      {/* TOP BAR */}

      <div style={styles.topBar}>

        <div style={styles.logo}>
          ELEVEN
        </div>

        
        <div style={styles.search}>
       <Search size={16} strokeWidth={2} style={styles.searchIcon} />

          <input
            placeholder="Search for jet ski parts..."
            style={styles.searchInput}
          />
        </div>

        <div style={styles.right}>
<div style={styles.account}>
  <User size={20} strokeWidth={1.8} />

  <div style={styles.accountText}>
    <div style={styles.accountHello}>Hello, Sign in</div>
    <div style={styles.accountLabel}>Account ▾</div>
  </div>
</div>

          <div style={styles.link}>Orders</div>

        <div style={styles.cart}>
  <ShoppingCart size={22} strokeWidth={1.8} />

  <div style={styles.badge}>3</div>
</div>
            

        </div>

      </div>

 {/* ELEVEN Divider */}

<div style={styles.brandDivider}>
  <span style={styles.line}></span>
  <span style={styles.brandText}>ELEVEN</span>
  <span style={styles.line}></span>
</div>

      {/* CATEGORY BAR */}

     <div style={styles.navBar}>

  <div style={styles.navLeft}>
    <div style={styles.menu}>
      <Menu size={18} strokeWidth={2} />
      All
    </div>

    <div style={styles.navItem}>Engines</div>
    <div style={styles.navItem}>Electrical</div>
    <div style={styles.navItem}>Pumps</div>
    <div style={styles.navItem}>Steering</div>
    <div style={styles.navItem}>OEM Parts</div>
  </div>

  <div style={styles.navRight}>
    <div style={styles.vehicle}>
      Update your Year / Make / Model
    </div>

  <button
  style={{
    ...styles.diagramButton,
    ...(diagramHover && styles.diagramButtonHover)
  }}
  onMouseEnter={() => setDiagramHover(true)}
  onMouseLeave={() => setDiagramHover(false)}
  onClick={() => navigate("/diagram")}
>
  ELEVEN Dealer Parts Diagram
</button>
  </div>
</div>
</div>
  );
}

export default MainHeader;


const styles = {

headerWrapper: {
  width: "100%",
  backdropFilter: "blur(14px)",
  WebkitBackdropFilter: "blur(14px)",
  background: "rgba(252,254,255,0.88)",
  boxShadow: "0 6px 30px rgba(0,0,0,0.06)",
  paddingBottom: 8
},

brandDivider: {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 12,
  padding: "8px 40px"
},

line: {
  flex: 1,
  height: 1,
  background: "rgba(0,0,0,0.08)"
},

brandText: {
  fontSize: 12,
  fontWeight: 600,
  letterSpacing: "0.45em",
  color: "#8E8E93"
},

topBar: {
  display: "flex",
  alignItems: "center",
  gap: 20,
  padding: "14px 28px"
},

logo: {
  fontSize: 22,
  fontWeight: 700,
  letterSpacing: "0.04em",
  fontFamily: "-apple-system, BlinkMacSystemFont, system-ui",
  cursor: "pointer"
},

delivery: {
  fontSize: 13,
  color: "#6e6e73"
},

search: {
  flex: 1,
  display: "flex",
  alignItems: "center",
  background: "#F2F2F7",
  borderRadius: 26,
  height: 40,
  paddingLeft: 14,
  border: "2px solid #FFFFFF",
  boxShadow: "0 0 12px rgba(255,255,255,0.9)"
},
searchIcon: {
  marginRight: 8,
  color: "#8E8E93"
},

searchInput: {
  border: "none",
  outline: "none",
  flex: 1,
  background: "transparent",
  fontSize: 15
},

account: {
  display: "flex",
  alignItems: "center",
  gap: 6,
  cursor: "pointer"
},

accountIcon: {
  fontSize: 20
},

accountText: {
  display: "flex",
  flexDirection: "column",
  lineHeight: "1.1"
},

accountHello: {
  fontSize: 12,
  color: "#6e6e73"
},

accountLabel: {
  fontSize: 14,
  fontWeight: 600
},


right: {
  display: "flex",
  alignItems: "center",
  gap: 24
},

link: {
  fontSize: 14
},

cart: {
  position: "relative",
  display: "flex",
  alignItems: "center",
  cursor: "pointer"
},

badge: {
  position: "absolute",
  top: -6,
  right: -8,
  background: "#007AFF",
  color: "white",
  borderRadius: "50%",
  width: 18,
  height: 18,
  fontSize: 12,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
},

navBar: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 40px",
  fontSize: 14
},


navLeft: {
  display: "flex",
  alignItems: "center",
  gap: 24
},


navRight: {
  display: "flex",
  alignItems: "center",
  gap: 16
},


vehicle: {
  fontSize: 13,
  color: "#6e6e73",
  cursor: "pointer"
},

diagramButton: {
  background: "#2563EB",
  color: "white",
  border: "none",
  padding: "10px 18px",   // thicker vertically
  borderRadius: 8,
  fontSize: 14,           // slightly larger text
  fontWeight: 600,
  cursor: "pointer",
  transition: "all 0.2s ease"
},

diagramButtonHover: {
  transform: "translateY(-2px)",
  boxShadow: "0 6px 14px rgba(37,99,235,0.35), 0 0 12px rgba(37,99,235,0.45)"
},

menu: {
  display: "flex",
  alignItems: "center",
  gap: 6,
  fontWeight: 600,
  cursor: "pointer"
},

navItem: {
  color: "#3a3a3c",
  cursor: "pointer"
}

};